import React, { useState, useEffect } from "react";
import { Modal, Button } from "./UI";
import { apiFetch } from "../../context/AppContext";
import { Clock, Trash2 } from "lucide-react";

export default function DeletedQuestionsLogModal({ open, onClose }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      fetchLogs();
    }
  }, [open]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await apiFetch(`/tenant/form-questions/deleted-logs`);
      if (res.ok) {
        const data = await res.json();
        setLogs(data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getFormLabel = (formKey) => {
    switch (formKey) {
      case "gap_assessment":
        return "Gap Assessment";
      case "ropa":
        return "ROPA";
      case "pia":
        return "PIA";
      case "tprm":
        return "TPRM";
      default:
        return formKey;
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Deleted Questions Logs" size="lg">
      <div className="space-y-4">
        {loading ? (
          <div className="py-12 text-center text-sm text-slate-400">Loading deleted logs...</div>
        ) : logs.length === 0 ? (
          <div className="py-12 text-center text-sm text-slate-400">No deleted questions activity logs found.</div>
        ) : (
          <div className="max-h-[450px] overflow-y-auto pr-1 space-y-3">
            {logs.map((log) => (
              <div key={log.id} className="p-3.5 border border-red-100 bg-red-50/20 rounded-xl space-y-2">
                <div className="flex items-center justify-between gap-2 flex-wrap">
                  <div className="flex items-center gap-2">
                    <span className="w-6 h-6 rounded-full bg-red-50 flex items-center justify-center text-red-500">
                      <Trash2 size={12} />
                    </span>
                    <span className="text-xs font-semibold text-slate-800">{log.admin_name || log.admin_email}</span>
                    <span className="text-[10px] bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded font-medium">
                      {getFormLabel(log.form_key)}
                    </span>
                  </div>
                  <span className="text-[10px] text-slate-400 flex items-center gap-1">
                    <Clock size={10} />
                    {new Date(log.created_at).toLocaleString()}
                  </span>
                </div>
                <div className="bg-white border border-slate-100 rounded-lg p-2.5">
                  <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Deleted Question Text</span>
                  <p className="mt-0.5 text-xs text-slate-700 font-medium">{log.question_text}</p>
                </div>
                {log.details?.section_id && (
                  <div className="text-[11px] text-slate-500 font-medium pl-1">
                    Section: <span className="text-slate-700 font-semibold">{log.details.section_id}</span>
                    {log.details.external_id && (
                      <> | ID: <span className="font-mono text-slate-700 font-semibold">{log.details.external_id}</span></>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="flex justify-end pt-2">
          <Button onClick={onClose} variant="secondary">Close</Button>
        </div>
      </div>
    </Modal>
  );
}
